import { render, staticRenderFns } from "./fromlist.vue?vue&type=template&id=078260be&scoped=true&"
import script from "./fromlist.vue?vue&type=script&lang=js&"
export * from "./fromlist.vue?vue&type=script&lang=js&"
import style0 from "./fromlist.vue?vue&type=style&index=0&id=078260be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078260be",
  null
  
)

export default component.exports